module.exports = __webpack_public_path__ + "static/media/logo192.7714d484.png";